import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { pexios, uploadImages } from '../../utils/functions';
import ExpertImage from '../../components/expert/ExpertImage';
import ImagePickerModal from '../../components/master/ImagePickerModal';
import addImage from '../../assets/images/AddImagePlaceholder/addImage.png'
import { history, url } from '../../utils/variables';
import Modal from '../../components/master/Modal';
import RegisterVideo from '../../components/pages/register/Video';
import ImageZoom from '../../components/master/ImageZoom';
import { t } from 'i18next';
import HeaderIcon from '../../assets/images/header-icon/camera.png'


export default function RegisterImages() {

    const { id } = useSelector(store => store.routerData);

    const [register, setRegister] = useState({
        attachments: [],
        car: {},
    });
    const [step,setStep] =useState(0)
    const [imageUID, setImageUID] = useState(null);
    useEffect(() => {
        pexios('api/get_register_attachment', 'post',{ id })
            .then(res => {
                setRegister(res.data.data);
            });

    }, [id]);

    function finishUpload(image, name, done) {
        uploadImages({
            id,
            type: 'register',
            name,
            image,
            done,
            callback: (data) => {
                setRegister(prevState => ({
                    ...prevState,
                    attachments: [
                        ...prevState.attachments,
                        data,
                    ],
                }));
            },
        });
    }
    function changeStep() {
        setStep(1);
    }

    return (
        <div className='content details'>
            <div className='title-image'>
                <img src={HeaderIcon} alt="icon"/>
            </div>
            {step === 0 && 
            <>
            <div className='gridParent'>
                <ExpertImage
                    title={t('Vehicle plate')}
                    src={register.attachments.filter(itm => itm.filename.includes('plate'))}
                    upload={(img, done) => finishUpload(img,'expert_plate', done)}
                    label='expert_plate'
                />
                <ExpertImage
                    title={t('Vehicle card')}
                    src={register.attachments.filter(itm => itm.filename.includes('vehicle_card'))}
                    upload={(img, done) => finishUpload(img,'expert_vehicle_card', done)}
                    label='vehicle_card_image'
                />
                <ExpertImage
                    title={t('Vehicle card back')}
                    src={register.attachments.filter(itm => itm.filename.includes('vehicle_card_back'))}
                    upload={(img, done) => finishUpload(img,'expert_vehicle_card_back', done)}
                    label='vehicle_card_back_image'
                />
                <ExpertImage
                    title={t('Green card')}
                    src={register.attachments.filter(itm => itm.filename.includes('green_card'))}
                    upload={(img, done) => finishUpload(img,'expert_green_card', done)}
                    label='green-card'
                />
                <ExpertImage
                    title={t('Front vehicle')}
                    src={register.attachments.filter(itm => itm.filename.includes('car-front'))}
                    upload={(img, done) => finishUpload(img,'expert_car-front', done)}
                    label='front_image'
                />
                <ExpertImage
                    title={t('Back vehicle')}
                    src={register.attachments.filter(itm => itm.filename.includes('car_back'))}
                    upload={(img, done) => finishUpload(img,'expert_car_back', done)}
                    label='back_image'
                />
                <ExpertImage
                    title={t('Left side vehicle')}
                    src={register.attachments.filter(itm => itm.filename.includes('car-left'))}
                    upload={(img, done) => finishUpload(img,'expert_car-left', done)}
                    label='left_image'
                />
                <ExpertImage
                    title={t('Right side vehicle')}
                    src={register.attachments.filter(itm => itm.filename.includes('car-right'))}
                    upload={(img, done) => finishUpload(img,'expert_car-right', done)}
                    label='right_image'
                />
                <ExpertImage
                    title={t('Motor image')}
                    src={register.attachments.filter(itm => itm.filename.includes('motor'))}
                    upload={(img, done) => finishUpload(img,'expert_motor', done)}
                    label='motor'
                />
                <ExpertImage
                    title={t('Engraved chassis number')}
                    src={register.attachments.filter(itm => itm.filename.includes('chassis'))}
                    upload={(img, done) => finishUpload(img,'expert_chassis', done)}
                    label='chassis_number'
                />
                {/* <ExpertImage
                    title='داخل کابین'
                    src={register.attachments.filter(itm => itm.filename.includes('cabin'))}
                    upload={(img, done) => finishUpload(img,'expert_cabin', done)}
                /> */}
                <ExpertImage
                    title={t('Kilometr image')}
                    src={register.attachments.filter(itm => itm.filename.includes('kilometer'))}
                    upload={(img, done) => finishUpload(img,'expert_kilometer', done)}
                    label='kilometer'
                />
                <ExpertImage
                    title={t('Dashboard')}
                    src={register.attachments.filter(itm => itm.filename.includes('dashboard'))}
                    upload={(img, done) => finishUpload(img,'expert_dashboard', done)}
                    label='dashboard'
                />
                {
                    register.car.car_type_id === 1 &&
                        <>
                            <ExpertImage
                                title={t('Car ceiling')}
                                src={register.attachments.filter(itm => itm.filename.includes('car-ceiling'))}
                                upload={(img, done) => finishUpload(img,'expert_car-ceiling', done)}
                                label='car-ceiling'
                            />
                            <ExpertImage
                                title={t('Trunk')}
                                src={register.attachments.filter(itm => itm.filename.includes('trunk'))}
                                upload={(img, done) => finishUpload(img,'expert_trunk', done)}
                                label='trunk'
                            />
                        </>
                }
                {
                    [6, 7, 9].includes(register.car.car_type_id) &&
                        <>
                            <ExpertImage
                                title={t('Tire')}
                                src={register.attachments.filter(itm => itm.filename.includes('tire'))}
                                upload={(img, done) => finishUpload(img,'expert_tire', done)}
                                label='tire'
                            />
                            <ExpertImage
                                title={t('Using')}
                                src={register.attachments.filter(itm => itm.filename.includes('using'))}
                                upload={(img, done) => finishUpload(img,'expert_using', done)}
                            />
                        </>
                }
            </div>
            <div className='d-flex justify-center mt20 pr5 pl5'>
                <button onClick={()=> setStep(1)} className='btn btn-white-purple w-50 btn-circle'>
                    {t('Next step')}
                </button>
            </div>
            </>
            }
            {step === 1 &&
            <>
            <Modal visible={imageUID}>
                <div className='image-modal'>
                    <i className='fas fa-times'
                        onClick={() => setImageUID(null)}
                    />
                    <ImageZoom imgUid={imageUID}/>
                </div>
            </Modal>
            <div className='gridParent'>
                <div className='crashGrid'>
                
                <div className=' register-complete-img'>
                    {/* <p className='mr5 mb10'>{t('Completment image')}</p> */}
                    <p className='guide-text mb10'> تصاویر تکمیلی خود را بارگذاری نمایید.</p>
                    <div className='row'>
                    {
                        register.attachments
                            .filter(img => (img.filename.includes('expert_extra')))
                            .map((img) => (
                                <div className='imageBox' key={img.id}>
                                    <img
                                        src={`${url}/files?uid=${img.uid}&width=150&height=150`}
                                        alt='img'
                                        className='img'
                                        onClick={() => setImageUID(img.uid)}
                                    />
                                </div>
                            ))
                    }
                    <div className='imageBox'>
                        <ImagePickerModal
                            // renderBtn={
                            //     <div className='defaultImage' />
                            // }
                            renderBtn={<img src={addImage} alt='img'/>}
                            upload={(image, done) => finishUpload(image,`expert_extra${register.attachments.filter(img => img.filename.includes('expert_extra')).length + 1}`, done)}
                        />
                    </div>
                    </div>
                </div>
                </div>
            </div>
            {/* {
                    !register.movie &&
                    <div className='gridParent'>
                        <div className='crashGrid'>
                            <RegisterVideo 
                                registerId={register.id} 
                                type='expert'
                            />
                        </div>
                    </div>
                } */}
            <div className='d-flex justify-center mt20 pr5 pl5'>
                <Link to='/register-pricing' className='btn btn-white-purple w-50 btn-circle'>
                    {t('Next step')}
                </Link>
                {/* <button onClick={()=>!register.movie ? history.push('/register-video') : history.push('/register-pricing')} className='btn btn-white-purple w-50 btn-circle'>
                    {t('Next step')}
                </button> */}
                
            </div>
            </>
            }
            {/* {step === 2 &&
            <>
            {
                    // !register.movie &&
                    <div className='gridParent'>
                        <div className='crashGrid'>
                            <RegisterVideo 
                                registerId={register.id} 
                                type='expert'
                            />
                        </div>
                    </div>
                }
            </>
            } */}
            
        </div>
    );
}